import moment from "moment";

export const ColumnsDetailComments = (t) => (
    [
        {
            name: t('OrderDetailDashboard.ColumnOrderCommentDate'),
            columnheader: {textAlign: 'center'},
            selector: 'orderCommentDate',
            sortable: true,
            width: "170px",
            cell: row => moment(row.orderCommentDate).format('YYYY-MM-DD'),
            center: true
        },
        {
            name: t('OrderDetailDashboard.ColumnOrderComment'),
            selector: 'orderComment',
            columnheader: {textAlign: 'left'},
            sortable: true,
            cell: row => row.orderComment
        }    
    ]
)

  